/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.availableBoothTree = function() {
    var elem = expocadfx.element;
    var txt = expocadfx.txt;
    
	var availSizes = [];
	var arAvailableBooths = [];  ///   OR IN PAGE CONTROLL ???????
				//   Used in mouseover and click event handlers
    var listChanged = true;
	var htmlAvailBooths = null;		// html element
    
    document.addEventListener( "booths_changed", function() {
        listChanged = true;
    });

    function getListElements( booths, units) {        // booths, units, arAvailBooths, treeRoot
        var i = 0;
        var j = 0;
        var bth = null;
        var objAvailableSize = null;
        var result = null;
        var labelM = "";
        var labelF = "";
        var sizeIndex = -1;
        var numBooths = booths.length;			////////////////////////////////////
        var numSizes = 0;
        var childLen = 0;
        var arBth = null;
        var arIdx = null;
        var leaf =  null;
        var node = null;
        var list = null;
        var label = "";
        
        if( !listChanged) {
            return;
        }
        
        availSizes = [];
		arAvailableBooths = [];
            // can not use element utilities because it caches a reference to the element
		var oldList = document.getElementById("trA");  
		if( oldList !== null) {
			elem.elementById( "trcA").removeChild( oldList );
		}
        
        for( i = 0; i < numBooths; i++) {
            bth = booths[i];				/////////////////////////////////
            
            if( bth.status === "0") {
                if( bth.dimM === "" && bth.areaM === "") {
                    labelM = txt.AVAILABLE;
                }
                else {
                    labelM = bth.areaM + ", " + bth.dimM;
                }
                sizeIndex = isInAvailSizes( labelM);
                if( sizeIndex === -1) {
                    result = findNextSize( bth);        //  add new size to array
                    if( result.index === -1) {
                        result.index = availSizes.length;
                    }
                    if( bth.dimF === "" && bth.areaF === "") {
                        labelM = txt.AVAILABLE;
                    }
                    else {
                        labelF = bth.areaF + ", " + bth.dimF;
                    }
                    objAvailableSize = {
                        lblM: labelM,
                        lblF: labelF,
                        area: result.a,
                        ht: result.h,
                        width: result.w,
                        childBooths: bth.number,
                        childIndex: i
                    };
                    availSizes.splice( result.index, 0, objAvailableSize);
                }
                else {
                    // add child to node ( ?? insert sort ??)
                    availSizes[ sizeIndex].childBooths += "," + bth.number;
                    availSizes[ sizeIndex].childIndex += "," + i;
                }
            }
        }
//        console.log( "Available booth sizes - " + availSizes.length + " \n");
//        for( i = 0; i < availSizes.length; i++) {
//            console.log( availSizes[i].lblF);
//        }
        
        
            //  create html
        numSizes = availSizes.length;
        htmlAvailBooths = elem.treeRoot( "trA");    // 'ul' element
        
        for( i = 0; i < numSizes; i++) {
            if( units === "F") {		//////////////////////////////////////////////
                label = availSizes[i].lblF;
            }
            else {
                label = availSizes[i].lblM;
            }
            node = elem.newTreeNode( availSizes[i].childIndex, label, arAvailableBooths);
            arAvailableBooths.push( availSizes[i].childIndex);
            
            list = document.createElement( "ul");
            list.style.display = "none";
            
            arBth = availSizes[i].childBooths.split(",");
            
            // sort array with compare from list code
            
            arIdx = String(availSizes[i].childIndex).split( ",");
            childLen = arBth.length;
            for( j = 0; j < childLen; j++) {
                leaf = elem.newTreeLeaf( arIdx[j], arBth[j], arAvailableBooths);
                arAvailableBooths.push( arIdx[j]);
                
                list.appendChild( leaf);
            }
            node.appendChild( list);
            htmlAvailBooths.appendChild( node);
        }
        listChanged = false;
        //return htmlAvailBooths;  ???
        elem.elementById( "trcA").appendChild( htmlAvailBooths);
    }
    
    function findNextSize( bth) {
        var i = 0;
        var len = availSizes.length;
        var a = parseFloat( bth.areaM);
        var h = 0;
        var w = 0;
        var idx = -1;
        
        if( bth.dimM !== null && bth.dimM !== "") {
            h = parseFloat( bth.dimM);
            if( bth.dimM !== null && bth.dimM !== undefined ) {
                idx = bth.dimM.indexOf( "x");
                if( idx !== -1) {
                    w = parseFloat( bth.dimM.substr( idx));
                }
                else {
                    console.log( "ERROR --- parsing: " + bth.dimM);
                }
            }
            else {
                console.log( "Booth  " + bth.number + "  dimensions undefined  " + bth.dimM);
            }
        }
        
        var rtn = {
            index: len,
            a: a,
            h: h,
            w: w
        };
        
        for( i = 0; i < len; i++) {
            if( parseFloat(availSizes[i].area) >= a) {
                if( parseFloat(availSizes[i].area) > a || 
                   parseFloat(availSizes[i].ht) > h || 
                   parseFloat(availSizes[i].width) > w) {
                    rtn.index = i;
                    break;
                }
            }
        }
        return rtn;
    }
    
    function isInAvailSizes( label) {
        var i = 0;
        var len = availSizes.length;
        
        for( i = 0; i < len; i++) {
            if( availSizes[i].lblM === label) {
                return i;
            }
        }
        return -1;
    }
    
    function toggleAvailableLabels( units) {
        var element = elem.elementById("trA");
        if( element !== null) {
            var node = element.childNodes[0];
            var span = null;
            var len = availSizes.length;
            var i;

            for( i = 0; i < len; i++) {
                node.getElementsByTagName( "span")[1].textContent = (units === "F") ?
                    availSizes[i].lblF : availSizes[i].lblM;
                node = node.nextSibling;
            }
        }
    }
    
    function getAvailArray() {
        return arAvailableBooths;
    }

    return {
        getListElements: getListElements,
        getAvailBoothArray: getAvailArray,
        listChanged: listChanged,
        toggleAvailableLabels: toggleAvailableLabels
    };
};